import { useSelector } from 'react-redux'
import { useRouter } from 'next/router'
import { useEffect } from 'react'
import authSelector from '@/redux/selectors/auth'

// Shutdown mode: only allow access to the shutdown key retrieval page
const SHUTDOWN_PAGE = '/app/shutdown'

const NotLoggedIn = () => {
  return <div></div>
}

const WithAuthProtection = (Component) => {
  const Authenticated = () => {
    const router = useRouter()
    const { userData, checked } = useSelector(authSelector)

    useEffect(() => {
      if (!userData && checked) {
        router.replace('/')
      }
      // Shutdown mode: redirect all authenticated users to shutdown page
      // unless they're already on the shutdown page
      if (userData && router.pathname !== SHUTDOWN_PAGE) {
        router.replace(SHUTDOWN_PAGE)
      }
    }, [userData, router, checked])

    return userData ? <Component /> : <NotLoggedIn />
  }

  return Authenticated
}

export default WithAuthProtection
